module.exports = __webpack_public_path__ + "static/media/paypal-logo.15b16c64.jpeg";